window.dataLayer = window.dataLayer || [];
class Tracking {
  constructor() {
    this.initializeTracking();
  }

  initializeTracking() {
    this.setupViewTracking();
    this.setupClickTracking();
  }

  setupViewTracking() {
    const viewElements = document.querySelectorAll("[data-tracking]");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.trackView(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        threshold: 0.01,
        rootMargin: "50px",
      }
    );

    viewElements.forEach((element) => observer.observe(element));
  }

  setupClickTracking() {
    const trackingBlocks = document.querySelectorAll(".has-tracking");
    trackingBlocks.forEach((block) => {
      const clickableElements = block.querySelectorAll("[data-tracking-click]");
      clickableElements.forEach((element) => {
        element.addEventListener("click", (event) => {
          event.stopPropagation();
          this.trackClick(block);
        });
      });
    });
  }

  getTrackingData(element, type = "view") {
    const eventName =
      type === "view"
        ? element.dataset.trackingView
        : element.dataset.trackingClickName;

    const attribute1Name = element.dataset.attribute1Name;
    const attribute1Value = element.dataset.attribute1Value;
    const attribute2Name = element.dataset.attribute2Name;
    const attribute2Value = element.dataset.attribute2Value;

    const data = { event: eventName };

    if (attribute1Name && attribute1Value) {
      data[attribute1Name] = attribute1Value;
    }
    if (attribute2Name && attribute2Value) {
      data[attribute2Name] = attribute2Value;
    }

    return data;
  }

  trackView(element) {
    const data = this.getTrackingData(element, "view");

    var { event, ...params } = data;
    gtag('event', event, params);
  }

  trackClick(element) {
    const trackingElement = element.querySelector("[data-tracking]");
    if (!trackingElement) return;

    const data = this.getTrackingData(trackingElement, "click");

    var { event, ...params } = data;
    gtag('event', event, params);
  }
}

// Initialize tracking
new Tracking();
